<template>
  <v-form ref="helpMenuForm" v-model="valid" lazy-validation>
    <v-container>
      <h2>Soru Ekle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="12">
          <h4>Soru</h4>
          <v-text-field
            v-model="helpMenuContent.title"
            maxlength="120"
            counter="120"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <h4>Cevap</h4>
          <v-textarea
            maxlength="10000"
            rows="1"
            auto-grow
            v-model="helpMenuContent.description"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>

      </v-row>
      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="12">
          <h4>Soru[EN]</h4>
          <v-text-field
            v-model="helpMenuContent.titleEn"
            maxlength="120"
            counter="120"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <h4>Cevap[EN]</h4>
          <v-textarea
            maxlength="10000"
            rows="1"
            auto-grow
            v-model="helpMenuContent.descriptionEn"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <h4>Kategori</h4>

          <v-select
            v-model="helpMenuContent.helpMenuId"
            :items="helpMenuCategoryList"
            item-text="title"
            item-value="id"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Sorunun uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="helpMenuContent.priority"
            type="number"
            min="0"
            required
            @input="handleInput"
          ></v-text-field>
        </v-col>


        <v-col cols="12" md="3">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="helpMenuContent.active" color="#4d48f9"></v-checkbox>
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="helpMenuContentAdd()"
          >EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline"
          >Lütfen alanları kontrol edin
          </v-card-title
          >

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "helpMenuContent",
  data: () => ({
    alert: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    titleRules: [
      (v) => !!v || "Soru alanı zorunludur.",
      (v) => v.length <= 120 || "Maksimum 120 karakter olmalıdır."
    ],
    descriptionRules: [
      (v) => !!v || "Cevap alanı zorunludur."
    ],
    noRule: [],
    helpMenuContentLinkTypes: [
      {
        name: "İç Link",
        value: "105"
      },
      {
        name: "Dış Link",
        value: "105"
      }
    ],
    helpMenuContent: {
      title: "",
      titleEn: "",
      description: "",
      descriptionEn: "",
      helpMenuId: 0,
      active: true,
      priority: 0
    },
    menu: false,
    errorList: [],
    dialog: false
  }),
  computed: mapGetters(["helpMenuCategoryList"]),

  created() {

    this.getHelpMenuCategoryList();

  },
  methods: {
    ...mapActions(["createContent", "getHelpMenuCategoryList"]),

    routeList() {
      this.$router.push("/dashboard/helpMenuContents");
    },
    handleInput(item) {
      if (item.includes(".")) this.campaign.userCount = item.replace(".", "");
    },
    helpMenuContentAdd() {
      console.log("21");
      console.log(this.$refs.helpMenuForm);

      if (this.$refs.helpMenuForm.validate()) {
        this.snackbar = true;
        this.createContent(this.helpMenuContent)
          .then((response) => {
            if (response.processStatus === "Success") {
              this.routeList();
            } else {
              alert(response.friendlyMessage.message);
            }
          })
          .catch((err) => {
            alert(err);
          });
      } else {

        var errors = [];
        var x = document.getElementsByClassName("v-messages__message");
        console.log(x);
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML);
        this.errorList = errors;
        this.dialog = true;
      }
    }
  }

};
</script>
